import * as t from 'io-ts';

import {makeApiType, makeEnumRuntimeType} from './apiTypes';

/*
 * Enum.
 */

export enum RelativeTimeUnitsEnum {
  MINUTE = 'minute',
  HOUR = 'hour',
  DAY = 'day',
  WEEK = 'week',
}

/*
 * Runtime type.
 */

const RCustomSnoozeDirty = t.readonly(
  t.type({
    name: t.string,
    relativeTo: t.union([makeEnumRuntimeType(RelativeTimeUnitsEnum), t.null]),
    offset: t.partial({
      month: t.Integer,
      week: t.Integer,
      day: t.Integer,
      hour: t.Integer,
      minute: t.Integer,
    }),
  }),
  'customSnooze',
);

const RSettingsCustomSnoozeDirty = t.intersection([RCustomSnoozeDirty, t.type({id: t.Integer})]);

/*
 * Type.
 */

export interface SettingsCustomSnoozeModel extends t.TypeOf<typeof RSettingsCustomSnoozeDirty> {}
export interface CustomSnoozeModel extends t.TypeOf<typeof RCustomSnoozeDirty> {}
export const RCustomSnooze = t.clean<CustomSnoozeModel>(RCustomSnoozeDirty as any);

/*
 * IO methods.
 */

export function parseCustomSnooze(src: any): CustomSnoozeModel {
  let relativeTo;
  switch (src.relativeTo) {
    case null:
      relativeTo = null;
      break;

    case 'd':
      relativeTo = RelativeTimeUnitsEnum.DAY;
      break;

    case 'm':
      relativeTo = RelativeTimeUnitsEnum.MINUTE;
      break;

    default:
      throw new Error(`Could not parse Custom Snooze with Unit: ${src.relativeTo}`);
  }

  return {
    name: src.name,
    relativeTo,
    offset: {
      month: src.mo,
      week: src.w,
      day: src.d,
      hour: src.h,
      minute: src.m,
    },
  };
}

export function serializeCustomSnooze(src: CustomSnoozeModel): any {
  let relativeTo;
  switch (src.relativeTo) {
    case null:
      relativeTo = null;
      break;
    case RelativeTimeUnitsEnum.DAY:
      relativeTo = 'd';
      break;

    case RelativeTimeUnitsEnum.MINUTE:
      relativeTo = 'm';
      break;

    default:
      throw new Error(`Could not serialize Custom Snooze with Unit: ${src.relativeTo}`);
  }
  return {
    name: src.name,
    relativeTo,
    mo: src.offset.month,
    w: src.offset.week,
    d: src.offset.day,
    h: src.offset.hour,
    m: src.offset.minute,
  };
}

/*
 * API type.
 */

export const ApiCustomSnooze = makeApiType('customSnooze', RCustomSnooze, parseCustomSnooze);
